import { Dispatch, SetStateAction, useCallback } from 'react';
import ActionsMenu from '../../../../components/ActionsMenu/ActionsMenu.component';
import { ITaskGroup } from '../../../../models/taskGroup.types';
import { ActionMenuItem } from '../../../../components/ActionsMenu/ActionsMenu.types';
import { MessageModal } from '../../ExaminerTreemap.types';
import { SubText } from '../../../../components/Prompt/Prompt.component';

export type UseSampleAssessmentGroupChairmanActionsMenuProps = {
  data: ITaskGroup[];
  setAction: Dispatch<SetStateAction<string>>;
  setMessageModal: React.Dispatch<React.SetStateAction<MessageModal>>;
  setEditExaminerNumberModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAssignSampleAssessmentGroupChairmanDialogVisible: React.Dispatch<React.SetStateAction<boolean>>;
  selectedTaskGroup: React.MutableRefObject<ITaskGroup | undefined>;
  setPromptSubTexts: React.Dispatch<React.SetStateAction<SubText[] | undefined>>;
  setPromptMainText: React.Dispatch<React.SetStateAction<string>>;
  setIsConfirmationPromptVisible: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItemId: React.MutableRefObject<string>;
};

export const useSampleAssessmentGroupChairmanActionsMenu = ({
  data,
  setAction,
  setMessageModal,
  setEditExaminerNumberModalOpen,
  setIsAssignSampleAssessmentGroupChairmanDialogVisible,
  selectedTaskGroup,
  setIsConfirmationPromptVisible,
  setPromptMainText,
  setPromptSubTexts,
  selectedItemId,
}: UseSampleAssessmentGroupChairmanActionsMenuProps) => {
  const displayRemoveSampleAssessmentGroupChairmanAssignmentPrompt = useCallback(() => {
    const taskGroup = data.find(
      (taskGroup) =>
        taskGroup.sampleAssessmentGroup?.sampleAssessmentChairman.sampleAssessmentChairmanId === selectedItemId.current,
    );
    if (taskGroup) {
      selectedTaskGroup.current = taskGroup;
      setPromptMainText('Czy na pewno chcesz usunąć Egzaminatorowi:');
      const subTexts: SubText[] = [
        {
          text: `${taskGroup.sampleAssessmentGroup?.sampleAssessmentChairman.examiner.firstName} ${taskGroup.sampleAssessmentGroup?.sampleAssessmentChairman.examiner.lastName}`,
        },
        { text: 'przypisaną funkcję Przewodniczącego ZWO?', isBold: true },
      ];
      setPromptSubTexts(subTexts);
      setIsConfirmationPromptVisible(true);
    }
  }, [data]);

  const getSampleAssessmentGroupChairmanActionsMenu = useCallback(
    (item: ITaskGroup, rowIndex: number): JSX.Element => {
      const menuItems: ActionMenuItem[] = [];
      const isChairmanExist =
        item.sampleAssessmentGroup && !!item.sampleAssessmentGroup.sampleAssessmentChairman.examiner;

      if (isChairmanExist) {
        menuItems.push({
          text: 'Usuń przewodniczącego z ZWO',
          onClick: () => {
            setAction('Usuń przewodniczącego z ZWO');
            displayRemoveSampleAssessmentGroupChairmanAssignmentPrompt();
          },
        });
        menuItems.push({
          text: 'Wyślij wiadomość',
          onClick: () => {
            setAction('Wyślij wiadomość');
            setMessageModal({ open: true, type: 'standard' });
          },
        });
        menuItems.push({
          text: 'Edytuj numer egzaminatora',
          onClick: () => {
            setAction('Edytuj numer egzaminatora');
            setEditExaminerNumberModalOpen(true);
          },
        });
      } else {
        menuItems.push({
          text: 'Przypisz KGZ do Przewodniczącego ZWO',
          onClick: () => {
            setAction('Przypisz KGZ do Przewodniczącego ZWO');
            setIsAssignSampleAssessmentGroupChairmanDialogVisible(true);
          },
        });
      }
      return <ActionsMenu menuItems={menuItems} rowIndex={rowIndex} />;
    },
    [displayRemoveSampleAssessmentGroupChairmanAssignmentPrompt, setAction, setMessageModal],
  );

  return {
    getSampleAssessmentGroupChairmanActionsMenu,
  };
};
